@if (translationsReady) {
  <div class="container-fluid" [ngClass]="withPadding ? 'p-3' : ''">
    <span class="m-0 subheadText">{{ title | translate }}{{ subtitle ? ' - ' + (subtitle | translate) : '' }}</span>
    <div [ngClass]="withPadding ? 'padding-container' : ''">
      <div [id]="chartDivId"></div>
      @if (noDataOnChart) {
        <p>{{ 'STATISTICS.NO_CHART_DATA' | translate }}</p>
      }
      @if (wrongData) {
        <p>{{ 'STATISTICS.WRONG_DATA' | translate }}</p>
      }
    </div>
  </div>
}
